<app-header
  class="mcm-metric-detail-header"
  extraClasses="mcm-header--modal"
  [title]="title() | translate"
  [showBackButton]="false">
  <ng-template mcmTemplate="end-buttons">
    <app-button
      icon="close-outline"
      extraClasses="mcm-button--xxl"
      (onClick)="closeModal.emit()" />
  </ng-template>
</app-header>
